import React from 'react';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import * as kratos from '@ory/kratos-client';

import {
  kratosApi,
  BodyValues,
  bodyValueExtractor
} from './kratos/common';

import { useInitFlow } from './kratos/useInitFlow';
import Flow from './kratos/Flow';


/*
React Component providing a Settings UI.
*/
export default function Settings() {
  const flowType = 'settings';

  const {
    flowId, initFlowQuery, initFlowStatusElement
  } = useInitFlow(flowType, initFlow);

  if (flowId === '') {
    return initFlowStatusElement;
  }

  const flow = <Flow
    flowId={flowId}
    flowType={flowType}
    flowGetter={getFlow}
    flowSubmitter={submitFlow(flowId)} />;

  return (
    <Container>
      <Stack spacing={4}>
        <div></div>

        <Typography align="center" variant="h5">
          You can update your identity profile or change your password here.
        </Typography>

        {flow}

        <div></div>
      </Stack>
    </Container>);
}



const initFlow = () => async () => await
  kratosApi.createBrowserSettingsFlow();

const getFlow = (flowId: string) => async () => await
  kratosApi.getSettingsFlow({ id: flowId });

const submitFlow = (flowId: string) =>
  async (values: BodyValues, submitGroup: string) =>
{
  let body: kratos.UpdateSettingsFlowBody | null  = null;

  if (submitGroup === "profile") {
    body = getProfileBody(values);
  }
  if (submitGroup === "password") {
    body = getPasswordBody(values);
  }

  if (body === null) {
    throw Error("unexpected group name");
  }

  return await kratosApi.updateSettingsFlow({
    flow: flowId,
    updateSettingsFlowBody: body
  });
};


function getProfileBody(values: BodyValues): kratos.UpdateSettingsFlowBody
{
  const v = bodyValueExtractor(values);
  type Body = (
    kratos.UpdateSettingsFlowWithProfileMethod & { method: 'profile' }
  );
  const body: Body = {
    csrf_token: v('default-csrf_token'),
    traits: {
      email: v('profile-traits.email'),
      username: v('profile-traits.username'),
      phone: v('profile-traits.phone'),
      name: v('profile-traits.name')
    },
    method: 'profile' as const,
  };
  return body;
};


function getPasswordBody(values: BodyValues): kratos.UpdateSettingsFlowBody
{
  const v = bodyValueExtractor(values);
  type Body = (
    kratos.UpdateSettingsFlowWithPasswordMethod & { method: 'password' }
  );
  const body: Body = {
    csrf_token: v('default-csrf_token'),
    password: v('password-password'),
    method: 'password' as const
  };
  return body;
};
